import { defineMessage } from '@lingui/core/macro';
import { UnitJsonConfig } from '@/core/types/battle.types';

export const striletz: UnitJsonConfig = {
    id: 'striletz',
    unitName: defineMessage({ message: 'Striletz' }),
    stats: {
        hp: 65,
        stamina: 100,
        speed: 5,
        armor: 10,
        evasion: 10,
        rangedSkill: 90,
        armorPenetration: 0.0,
        critChance: 15,
        critMult: 1.4,
        initiative: 40,
        damageMin: 18,
        damageMax: 25,
    },
    skills: [
        {
        id: 'r_ar_shot',
        name: defineMessage({ message: 'Arrow Shot' }),
        sort: 10,
        cost: 60,
        range: 6,
        powerMult: 1,
        hitChanceBonus: 5,
        iconRow: 4,
        iconCol: 0,
    },
    ],
    anchor: {
        x: 0.47,
        y: 0.68,
    },
    badge: {
        x: 70,
        y: -190,
    },
    unitPortrait: {
        row: 0,
        col: 1,
    },
} satisfies UnitJsonConfig;
